import * as React from "react"

export const ObjectIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.224 15.583V14.5h1.309a.94.94 0 0 0 .687-.276.9.9 0 0 0 .28-.666V12.01q0-.807.556-1.365.558-.558 1.371-.622v-.004q-.815-.126-1.37-.674a1.83 1.83 0 0 1-.558-1.355V6.442a.9.9 0 0 0-.28-.666.94.94 0 0 0-.686-.276h-1.31V4.417h1.31q.857 0 1.454.592.596.592.596 1.433V7.99q0 .408.287.683a.98.98 0 0 0 .703.276h1.01v2.102h-1.01a.98.98 0 0 0-.703.276.9.9 0 0 0-.287.683v1.548q0 .841-.597 1.433a1.99 1.99 0 0 1-1.453.592h-1.31Zm-5.758 0q-.85 0-1.45-.592a1.94 1.94 0 0 1-.6-1.433V12.01a.9.9 0 0 0-.288-.683.98.98 0 0 0-.702-.276h-1.01V8.95h1.01q.414 0 .702-.276a.9.9 0 0 0 .288-.683V6.442q0-.84.6-1.433.6-.592 1.45-.592h1.317V5.5H6.466a.94.94 0 0 0-.683.276.9.9 0 0 0-.284.666V7.99q0 .828-.553 1.386-.552.559-1.375.622v.007q.823.04 1.375.609.553.569.553 1.396v1.548q0 .39.284.666.285.276.683.276h1.317v1.083z"
    ></path>
  </svg>
)
